import React from 'react';

const LandingSubText = ({ children, additionalclasses }) => {
    return (
        <p className={`text-grey-900 text-[16px] lg:text-[18px] leading-[24px] tracking-[-0.4px] text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default LandingSubText;